import React from "react";
import styled from "styled-components";
import { Table, Empty } from "antd";

import colors from "constants/palette";

// const horizontalPadding = "5%";

export default function CustomeTable(props) {
  return (
    <CustomTable
      {...props}
      locale={{
        emptyText: (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={<span>نتیجه ای یافت نشد </span>}
          />
        ),
      }}
    />
  );
}
const CustomTable = styled(Table)`
  & .ant-table {
    border-radius: 6px;
    overflow: auto;
  }
  & .ant-table,
  .ant-table-cell {
    background-color: ${colors.white + "80"};
    border-color: #79797942;
    color: ${colors.dark};
  }

  & .ant-table-tbody > tr.ant-table-row:hover > td,
  .ant-table-tbody > tr > td.ant-table-cell-row-hover,
  .ant-table-tbody > tr.ant-table-placeholder:hover > td {
    background-color: ${colors.primary + "10"};
  }
  & .ant-pagination-item a,
  .ant-pagination-item-link {
    background-color: ${colors.white};
    color: ${colors.dark};
  }
  & .ant-table-pagination.ant-pagination {
    direction: ltr;
  }
  & .ant-empty-description {
    color: ${colors.dark};
  }
`;
// const Container = styled.div``;
// const Header = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-content: center;
//   background: #e8e8e8;
//   padding: 16px ${horizontalPadding};
//   border-radius: 5px;
// `;
// const HeaderItem = styled.span`
//   width: 20%;
//   text-align: center;
// `;
// const Item = styled.span`
//   width: 20%;
//   text-align: center;
// `;
// const Body = styled.div`
//   display: flex;
//   flex-direction: column;
//   justify-content: space-between;
//   align-content: center;
//   padding: 16px ${horizontalPadding};
//   border-radius: 5px;
// `;
